// @ts-strict-ignore
import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMFormPersonalization } from '@states/models/lm-form-personalization.model';
import { LMFormState } from '@states/models/lm-form-state.model';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMModel } from '@form/model/lm-model';
import { LMFormManualRepService } from './lm-form-manual-rep.service';
import { LMHtmlUrlDocComponent } from '@html/lm-html-url-doc.component';
import { Observable } from 'rxjs';
import {LMInvalidFieldEvent} from "@app/components";

@Component({
  selector:    'lm-form-content-manual-representation',
  providers:   [LMFormManualRepService],
  templateUrl: 'lm-form-content-manual-representation.component.html',
  styleUrls:   [ 'lm-form-content-manual-representation.component.scss' ]
})

export class LMFormContentManualRepresentationComponent implements AfterViewInit, OnInit {

  @ViewChild('LMHtmlUrlDoc', { static: true }) htmlDocComponent: LMHtmlUrlDocComponent;

  @Input() formSpec: LMFormSpec = null;
  @Input() formOptions: LMFormOptions = null;

  @Input() specFields: LMSpecFields;
  @Input() layout: LMFormLayout;
  @Input() model: LMModel;
  @Input() formState: LMFormState;
  @Input() chartFields: any;
  @Input() set fromDataView(dataView: LMDataView) {
    this._fromDataView = dataView;
    this.build();
  }
  @Input() placeHolder: ViewContainerRef;
  @Input() formPersonalization: LMFormPersonalization;

  @Output() contentModified = new EventEmitter<any>();

  public url: string;

  private _fromDataView: LMDataView;

  constructor(private lmLoggerService: LMLoggerService,
    private lmFormatUtilService: LMFormatUtilService,
    private lmFormManualRepService: LMFormManualRepService) {
  }

  ngOnInit() {
    this.lmFormManualRepService.setDataView(this.model.getData());
    this.lmFormManualRepService.setFormSpec(this.formSpec);

    this.url = 'http://usspnswolynie2.infor.com:2041/uitest/web/samples/iframetest/test.html';
    this.build();
  }

  ngAfterViewInit() {
    // this.lmLoggerService.log([ this, 'ngAfterViewInit', 'this.form.valid=', this.form.valid ]);
  }

  onContentModified(event: any) {
    this.contentModified.emit(event);
  }

  public isModified(): boolean {
    return this.htmlDocComponent.isModified();
  }

  runRefresh() {
    // TODO Stan this is called when the user runs a form refresh
    // You may want to tell the htmlDocument to refresh
  }

  public runSave(): Observable<boolean>  {

    return new Observable<boolean>(observer => {
      this.htmlDocComponent.runSave();
      observer.next(true);
      observer.complete();

    });
  }

  handleBlockingErrorField(event: LMInvalidFieldEvent) {
    event.alert.scrollIntoView(false);
  }

  private build() {
    // this.formState
  }
}
